import type Discount from './discount';
import type NonNegativeNumber from './non-negative-number';
import type Currency from './sales/currency';
import { assertIsInstanceOfCurrency, assertIsInstanceOfDiscountOrNull, assertIsInstanceOfNonNegativeNumber } from './assertions';

interface IPrice extends IPriceInit {}

interface IPriceInit {
	readonly costPrice: NonNegativeNumber;
	readonly currency: Currency;
	readonly discount: Discount | null;
	readonly listPrice: NonNegativeNumber;
	readonly salesPrice: NonNegativeNumber;
}

export default class Price implements IPrice {
	public get costPrice(): NonNegativeNumber {
		return this.#costPrice;
	}

	public get currency(): Currency {
		return this.#currency;
	}

	public get discount(): Discount | null {
		return this.#discount;
	}

	public get listPrice(): NonNegativeNumber {
		return this.#listPrice;
	}

	public get salesPrice(): NonNegativeNumber {
		return this.#salesPrice;
	}

	public get salesPriceFormatted(): string {
		if (this.currency.key.value === 'DKK') {
			return new Intl.NumberFormat('da', this.#formatOptions).format(this.salesPrice.value);
		} else if (this.currency.key.value === 'SEK') {
			return new Intl.NumberFormat('sv', this.#formatOptions).format(this.salesPrice.value);
		}
		return new Intl.NumberFormat('en', this.#formatOptions).format(this.salesPrice.value);
	}

	#costPrice: NonNegativeNumber;
	#currency: Currency;
	#discount: Discount | null;
	#formatOptions: Intl.NumberFormatOptions;
	#listPrice: NonNegativeNumber;
	#salesPrice: NonNegativeNumber;
	public constructor({ costPrice, currency, discount, listPrice, salesPrice }: IPriceInit) {
		assertIsInstanceOfNonNegativeNumber(costPrice);
		this.#costPrice = costPrice;
		assertIsInstanceOfCurrency(currency);
		this.#currency = currency;
		assertIsInstanceOfDiscountOrNull(discount);
		this.#discount = discount;
		assertIsInstanceOfNonNegativeNumber(listPrice);
		this.#listPrice = listPrice;
		assertIsInstanceOfNonNegativeNumber(salesPrice);
		this.#salesPrice = salesPrice;
		this.#formatOptions = { currency: this.#currency.key.value, style: 'currency' };
	}
}
